const RECENT_SEARCHES_KEY = 'stockroom_recent_searches';
const MAX_RECENT = 6;

export function getRecentSearches() {
  try {
    const raw = localStorage.getItem(RECENT_SEARCHES_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.slice(0, MAX_RECENT) : [];
  } catch {
    return [];
  }
}

export function addRecentSearch(label) {
  if (!label || typeof label !== 'string') return;
  const clean = label.trim();
  if (!clean) return;
  try {
    const existing = getRecentSearches().filter(
      (item) => item.toLowerCase() !== clean.toLowerCase()
    );
    const next = [clean, ...existing].slice(0, MAX_RECENT);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable — ignore
  }
}

export function clearRecentSearches() {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch {
    // ignore
  }
}
